// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".myBox[data-v-6486541c] {\n  color: #222222;\n  border: 3px solid black;\n  padding: 2.5vw;\n  margin: 10px;\n  border-radius: 15px;\n}\n.myBox.noborder[data-v-6486541c] {\n  border-color: transparent;\n}\n.myBox.nopadding[data-v-6486541c] {\n  padding: 0;\n  margin: 0;\n}\nh2.kiosk[data-v-6486541c] {\n  color: white;\n}\nh4.kiosk[data-v-6486541c] {\n  color: white;\n}", ""]);
// Exports
module.exports = exports;
